import React from 'react';
import {View} from 'react-native';
import Screen from '../../../../../../shared/components/screen';
import {CustomScrollView} from '../../../../../../shared/components/scrollView';
import {InputFormMobile} from './InputFormIndex';
import {LoadableContent} from '../../../../../../shared/components/loadableContent';
import {useAccountLinker} from '../../../../../../shared/hooks/useAccountLinkerHook/useAccountLinker';

export function ProfileLinkedAccountsLinkAccount() {
  const {isLoading} = useAccountLinker();
  return (
    <Screen>
      <CustomScrollView contentInsetAdjustmentBehavior='automatic'>
        <LoadableContent loading={isLoading}>
          <View
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignSelf: 'center',
              justifyContent: 'center',
              width: '90%',
            }}>
            <InputFormMobile onClose={() => {}} />
          </View>
        </LoadableContent>
      </CustomScrollView>
    </Screen>
  );
}
